import { RewindRecording } from 'types/recordings';
import {
  getMatchingPlaylistTimesForRewind,
  createNewPlaylistBlock,
  updatePlaylistBlockWithRewind,
  addWavesToSmartRewindPlaylistBlock,
  getStartAndEndTimesFromAllRewinds,
  updateToSmartRewindPlaylistBlock,
} from './playlistBlocks';
import { addMissingRewindsErrors } from './rewindsErrorHelpers';
import { RewindPlaylists } from './playlistBlocks.types';

const SIXTY_MINUTES_IN_MS = 1000 * 60 * 60;

export const generateSmartRewindPlaylistBlocks = (
  rewinds: RewindRecording[],
  playlistBlockLengthInMs: number,
  playlistBlockOverlapInMs: number,
): RewindPlaylists => {
  const playlistBlocks = new Map();

  if (!rewinds || !rewinds.length) {
    console.error('ERROR: no rewinds returned from API');
    return playlistBlocks;
  }

  const { rewindsStartTimeInMs, rewindsEndTimeInMs } = getStartAndEndTimesFromAllRewinds(rewinds);

  const NOW_DATE_MS = new Date(Date.now()).getTime();

  const playlistStartTimeInMs = rewindsStartTimeInMs;
  let playlistsEndTimeInMs = rewindsEndTimeInMs;

  if (NOW_DATE_MS - rewindsEndTimeInMs > SIXTY_MINUTES_IN_MS) {
    playlistsEndTimeInMs = NOW_DATE_MS;
  }

  for (
    let matchingBlockEndTimeInMs = playlistsEndTimeInMs;
    matchingBlockEndTimeInMs > playlistStartTimeInMs;
    matchingBlockEndTimeInMs -= playlistBlockLengthInMs - playlistBlockOverlapInMs
  ) {
    const matchingTime = new Date(matchingBlockEndTimeInMs).toISOString();

    const basePlaylistBlock = createNewPlaylistBlock(matchingTime, playlistBlockLengthInMs);
    playlistBlocks.set(matchingTime, updateToSmartRewindPlaylistBlock(basePlaylistBlock));
  }

  rewinds.forEach((rewind) => {
    if (!rewind.startDate || !rewind.endDate) {
      console.error('ERROR: malformed rewind returned from API');
      return;
    }
    const matchingRewindTimes = getMatchingPlaylistTimesForRewind(
      rewind.startDate,
      rewind.endDate,
      playlistsEndTimeInMs,
      playlistBlockLengthInMs,
      playlistBlockOverlapInMs,
    );

    matchingRewindTimes.forEach((matchingTime) => {
      // this should never happen and is just incase of an ordering error in the api
      if (!playlistBlocks.has(matchingTime)) {
        const basePlaylistBlock = createNewPlaylistBlock(matchingTime, playlistBlockLengthInMs);
        playlistBlocks.set(matchingTime, updateToSmartRewindPlaylistBlock(basePlaylistBlock));
      }

      const updatedPlaylistBlockWithRewind = updatePlaylistBlockWithRewind(
        rewind,
        playlistBlocks.get(matchingTime),
      );
      const updatedPlaylistBlockWithWaves = addWavesToSmartRewindPlaylistBlock(
        rewind,
        updatedPlaylistBlockWithRewind,
      );
      playlistBlocks.set(matchingTime, updatedPlaylistBlockWithWaves);
    });
  });

  addMissingRewindsErrors(playlistBlocks as RewindPlaylists);

  return playlistBlocks;
};
